<div class="controller-card" [class.disabled]="disabled" [routerLink]="disabled ? null : ['/controller', controller.mac]">
  <span><span *ngIf="adminRole"><b>{{controller.username}}&nbsp;{{controller.mac}}&nbsp;</b></span>{{ controller.name }} - {{ controller.description }}<span class="via-bus" *ngIf="controller.online && controller.directConnected === false" [title]="'controllers.via_bus_hint' | translate"> {{ 'controllers.via_bus' | translate }}</span></span>
  <span class="status">
    <i [class.green]="controller.online" [class.red]="!controller.online"></i>
  </span>
</div>
